import { Reveal, GradientButton, GhostButton } from "@/components/common";
import { ArrowRight, Check } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { useCtaActions } from "@/lib/ctaActions";
import { useI18n } from "@/i18n";

export function FinalCTA() {
  const { goRegister } = useCtaActions();
  const { t } = useI18n();
  const points = t("finalCta.points");
  return (
    <section className="relative overflow-hidden bg-re-ink py-28 md:py-36" data-testid="final-cta">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[500px] w-[720px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gradient-red opacity-[0.28] blur-[130px]" />
      <div className="pointer-events-none absolute inset-0 grain opacity-[0.04]" />
      <div className="container-re relative text-center">
        <Reveal>
          <h2 className="mx-auto max-w-4xl px-2 pb-1 font-heading text-4xl font-black leading-[1.08] tracking-tight text-white md:text-6xl">
            {t("finalCta.title")} <span className="text-gradient-red">{t("finalCta.titleAccent")}</span>{t("finalCta.titleEnd")}
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mx-auto mt-6 max-w-2xl text-base text-white/60 md:text-lg">
            {t("finalCta.sub")}
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <GradientButton testid="final-primary-cta" onClick={() => goRegister()} className="w-full sm:w-auto">
              {t("finalCta.cta1")} <ArrowRight className="h-4 w-4" />
            </GradientButton>
            <GhostButton dark testid="final-secondary-cta" onClick={() => scrollToId("pakketten")} className="w-full sm:w-auto">
              {t("finalCta.cta2")}
            </GhostButton>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-8">
            {points.map((p) => (
              <span key={p} className="flex items-center gap-2 text-sm font-medium text-white/75">
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-gradient-red">
                  <Check className="h-3 w-3 text-white" strokeWidth={3} />
                </span>
                {p}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
